import React, {useEffect, useState} from 'react';
import _ from "lodash"
import axios from 'axios';

import TabLabel from '../Utilities/TabLabel';
import TabLoading from '../Utilities/TabLoading';
import PropertyValue from '../Utilities/PropertyValue';

const TeamsTab = props => {

  const [data, setData] = useState(null)

  useEffect(() => {
    props.setTabLabel(<TabLabel isLoading={true}>Teams</TabLabel>)
    axios.get(`/users/${props.user_id}/teams.json`).then((response) => {
      setData(response.data)
      props.setTabLabel(<TabLabel isLoading={false} hasWarnings={!_.isEmpty(response.data.warnings)}>Teams ({response.data.teams.length})</TabLabel>)
    }).catch((error) => {
      console.log('error loading user data')
    })
  }, [])

  function render() {
    if (data) {
      return (
        <React.Fragment key="app-details">
          <h2 className="slds-text-heading_medium">Teams</h2>

          <table className="slds-table slds-table_cell-buffer slds-table_bordered">
            <thead>
              <tr>
                <th>Team</th>
                <th>Role</th>
                <th>Type</th>
              </tr>
            </thead>

            <tbody>
              {data.teams.map((team) => {
                return(
                <tr key={team.id}>
                  <td><PropertyValue value={team.name} link={`/teams/${team.id}`} clipboard={true} /></td>
                  <td>{team.role}</td>
                  <td>{team.type}</td>
                </tr>
                )
              })}
              </tbody>
            </table>
          </React.Fragment>
      )
    } else {
      return(<TabLoading />)
    }
  }

  return render()
}

export default TeamsTab